import styled, { css } from 'styled-components';

import Input from '../_Input';

export const StyledInputWrapper = styled.span<{
  inputWidth?: number;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  width: ${({ inputWidth }) => inputWidth ? `${inputWidth}px` : 'auto'};
`;

export const StyledInput = styled(Input)<{
  hideCounter?: boolean;
  shaded?: boolean;
  minHeight?: number;
}>`
  display: block;
  cursor: text;
  resize: none;
  overflow: hidden;
  box-sizing: border-box;
  min-height: ${({ minHeight }) => minHeight}px;
  &::-ms-reveal, ::-ms-clear { display: none; } 
  padding: 9px;

  ${({ hideCounter }) => !hideCounter && css`
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  `}

  ${({ readOnly }) => !readOnly && css`
    &:not(:disabled) {
      &:focus {
        padding: 8px;
      }
    }
  `}
`;

export const StyledCounter = styled.span<{
  isMaxLengthInvalid?: boolean;
}>`
  background: ${({ theme }) => theme.colors.black08};
  padding: 8px 12px;
  font-size: 12px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  text-align: right;

  ${({ isMaxLengthInvalid }) => isMaxLengthInvalid && css`
    background: ${({ theme }) => theme.colors.red16};
  `}
`;
